import React, { useEffect, useState, useMemo } from "react";
import { formatDate } from "utils/utils";
import { DetailedViewCard } from "./detailed-view";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
export default function EmbedMilestoneCard({
  handleWatch,
//   handleImageGallery,
//   profile,
}) {
  const { http } = global.services;
  const [_milestone, setMilestone] = useState(null);
  const {t} = useTranslation();

  const { id } = useParams();

  const getShareMilestone = async () => {
    console.log("start share");
    const { data } = await http.get(`milestone/share/${id}`);
    console.log(data);
    setMilestone(data);
    console.log("End share");
  };

  useEffect(() => {
    getShareMilestone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const date = useMemo(() => {
    if (_milestone) {
      return formatDate(_milestone,false, t);
    }
  }, [_milestone]);

  return (
    <>
      {_milestone && (
        <div className="w-full">
            <DetailedViewCard
              mt="mt-0"
              featured={_milestone}
              details={_milestone}
              url={
                _milestone.thumbnail &&
                (_milestone.thumbnail.webp_url || _milestone.thumbnail.url)
              }
              title={_milestone.title}
              dateNote={_milestone.date_note}
              date={date}
              people={_milestone.people}
              positions={_milestone.positions}
              platform={_milestone.platform}
              description={_milestone.description}
              privacy={_milestone.privacy}
              isAdultContent={_milestone.is_adult_content ? true : false}
              category={_milestone.category?.name}
              buttons={_milestone.media_type}
            //   onWatchMedia={handleWatch}
            //   onViewImage={handleImageGallery}
              isYourProfile={false}
              share={false}
              organizeBy ="Job/Role"
              categories={_milestone?.categories}
              showItemList={false}
            />
        </div>
      )}
    </>
  );
}
